import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BlockComponent } from "@components/container-block/block.component";
import { KundorderTyp } from "~app/common/models/constants";
import { IKundorderDetailKundorder, IKundorderDetailKundorderrad } from "../../models/kundorder-detail-model";
import { KorHotComponent } from "./kor-hot/kor-hot.component";

@Component({
    selector: "rask-kundorderrad-details",
    templateUrl: "./kundorderrad-details.component.html",
    styleUrls: ["./kundorderrad-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        FormsModule,
        KorHotComponent
    ]
})
export class KundorderradDetailsComponent {
    @Input() kundorderrad: IKundorderDetailKundorderrad;
    @Input() kundorder: IKundorderDetailKundorder;
    @Input() canEdit: boolean;

    isTerminalorder(): boolean {
        return this.kundorder.kundordertyp === KundorderTyp.Terminalorder;
    }
}
